import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchOrganizations } from '../../api/organizations';
import { useOrganizationsStore } from '../../store';

export const OrganizationsLoader = ({ children }: { children: React.ReactNode }) => {
    const { data, isLoading, error } = useQuery({
        queryKey: ['organizations'],
        queryFn: fetchOrganizations,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 2,
    });

    const { setOrganizations, setLoading, setError } = useOrganizationsStore();

    useEffect(() => {
        if(data) {
            setOrganizations(data);
        }

        setError(error ? error.message : null);
        setLoading(isLoading);
    }, [data, isLoading, error, setOrganizations, setError, setLoading]);

    return <>{children}</>;
};